module.exports = __webpack_public_path__ + "static/media/Sumo Wrestler.5bedbff3.jpg";